import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
    // baseURL: 'http://192.168.0.200:3000/api', // 指向你的 Express 后端
    baseURL: 'https://www.wenqianlou.cn/api', // 指向你的 Express 后端
    timeout: 6000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 约定 code 200 为成功
        if (res.code !== 200) {
            message.error(res.msg || 'Error')
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        if (error.response && error.response.status === 401) {
            message.error('登录过期，请重新登录')
            localStorage.removeItem('token')
            router.push('/login')
        } else {
            message.error(error.message)
        }
        return Promise.reject(error)
    }
)

export default service